import React, { useState } from "react";
import { Field } from "react-final-form";
import { Col, Row } from "reactstrap";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { required, atLeastOneFieldRequired, composeValidators, isNotNaivePath, noPathTraversal } from "../../../util/validators";
import { AdministrateSelectInput } from "../../components/inputs/AdministrateSelectInput";
import { DropzoneInput } from "../../../components/inputs/final_form/DropzoneInput";
import { Switch } from "../../../components/inputs/final_form/Switch";

export const ReportDeliveryForm = ({ handleSubmit, submitting, deliveryMethod = null, resourceType, rawResourceId }) => {
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState(deliveryMethod);

  const onDeliveryMethodChange = (selected) => {
    setSelectedDeliveryMethod(selected.value);
  };

  const resourceKey = resourceType == "lab" ? "labSettingId" : "clinicId";

  return (
    <>
      <Row>
        <Col>
          <Field component={TextInput} required validate={required} name={resourceKey} readOnly type="hidden" />
          <Field
            component={AdministrateSelectInput}
            resourceUrl={`/admin/report_delivery_configs/report_type_options.json?report_delivery_config[resource_type]=${resourceType}`}
            label="Report Type"
            name="reportType"
            valueKey="value"
            labelKey="label"
            disabled={resourceType == "clinic"}
            required
            validate={required}
          />
          <Field
            component={AdministrateSelectInput}
            resourceUrl={`/admin/report_delivery_configs/delivery_method_options.json?report_delivery_config[resource_type]=${resourceType}`}
            label="Delivery Method"
            name="deliveryMethod"
            valueKey="value"
            labelKey="label"
            required
            validate={required}
            onUpdate={onDeliveryMethodChange}
          />
          <Field
            type="checkbox"
            component={Switch}
            required
            label="Auto delivery Enabled?"
            name="autoDeliveryEnabled"
            id="autoDeliveryEnabled"
          />
          {selectedDeliveryMethod === "email" && (
            <Field component={TextInput} required validate={required} label="Email Address" name="emailAddress" />
          )}
          {selectedDeliveryMethod === "sftp" && (
            <>
              <Field component={TextInput} required validate={required} label="Hostname" name="sftpHost" />
              <Field component={TextInput} required validate={required} label="Port" name="sftpPort" type="number" min="1" max="65535" />
              <Field component={TextInput} required validate={required} label="Username" name="sftpUsername" />
              <Field
                component={TextInput}
                required
                validate={atLeastOneFieldRequired("sftpKeyfile")}
                type="password"
                label="Password"
                name="sftpPassword"
              />
              <Field component={TextInput} required validate={required} label="Path" name="sftpPath" />
              <Field
                required
                validate={atLeastOneFieldRequired("sftpPassword")}
                component={DropzoneInput}
                accept={null}
                hint="Drop Keyfile"
                label="Keyfile"
                name="sftpKeyfile"
              />
            </>
          )}
          {selectedDeliveryMethod === "account" && (
            <Field
              component={AdministrateSelectInput}
              resourceUrl="/admin/accounts.json"
              valueKey="id"
              labelKey="full_name_or_email"
              label="Recipient"
              name="recipientId"
              required
              validate={required}
            />
          )}
          {selectedDeliveryMethod === "box" && (
            <Field component={TextInput} required validate={required} label="Box Folder Id" name="boxFolderid" />
          )}
          {selectedDeliveryMethod === "s3" && (
            <>
              <Field component={TextInput} required validate={required} label="Bucket Name" name="s3DirectoryAttributes.bucketName" />
              <Field
                component={TextInput}
                required
                validate={composeValidators(required, isNotNaivePath, noPathTraversal)}
                label="Prefix"
                name="s3DirectoryAttributes.prefix"
              />

              {resourceType === "lab" && (
                <Field component="input" type="hidden" name="s3DirectoryAttributes.labId" initialValue={rawResourceId} />
              )}
              {resourceType === "clinic" && (
                <Field component="input" type="hidden" name="s3DirectoryAttributes.clinicId" initialValue={rawResourceId} />
              )}
              <Field component="input" type="hidden" name="s3DirectoryAttributes.enabled" initialValue={true} />
              <Field component="input" type="hidden" name="s3DirectoryAttributes.dirType" initialValue="report" />

              <hr className="my-4" />
              <h5 className="text-muted">Advanced Options (Optional)</h5>

              <Field
                component={TextInput}
                label="Region (Optional)"
                name="s3DirectoryAttributes.s3Region"
                placeholder="Leave empty for default"
              />
              <Field
                component={TextInput}
                label="Endpoint (Optional)"
                name="s3DirectoryAttributes.s3Endpoint"
                placeholder="Endpoint URL, leave empty for default"
              />
              <Field
                component={TextInput}
                label="AWS Access Key (Optional)"
                name="s3DirectoryAttributes.s3AccessKeyId"
                placeholder="Access Key, leave empty for none"
              />
              <Field
                component={TextInput}
                label="AWS Secret Key (Optional)"
                type="password"
                name="s3DirectoryAttributes.s3SecretAccessKey"
              />
              <Field
                component={TextInput}
                label="Role ARN (Optional)"
                name="s3DirectoryAttributes.roleArn"
                placeholder="Leave empty for default internal access"
              />
              <Field
                component={TextInput}
                label="External ID (Optional)"
                name="s3DirectoryAttributes.externalId"
                placeholder="Required only for cross-account access"
              />
            </>
          )}
        </Col>
      </Row>
      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
